document.addEventListener('DOMContentLoaded', function () {

    class video extends HTMLElement{
        constructor () {
            super ();

            this.play = this.querySelector('.play');
            this.close = this.querySelector('.close');
            this.muted = this.querySelector('.muted');
            this.player = this.querySelector('video');

            if(!this.play || !this.player) return;

            this.play.addEventListener('click', this.playVideo.bind(this));
            if(this.close) this.close.addEventListener('click', this.closeVideo.bind(this));
            this.player.addEventListener('click', this.togglePause.bind(this));
        }

        playVideo () {
            setActive(this);
            this.player.muted = false;
            this.muted.classList.add('hidden');
            this.player.play();
        }

        closeVideo () {
            unsetActive(this);
            this.player.pause();
        }

        togglePause () {
            if(this.player.muted){
                this.player.muted = false;
                this.muted.classList.add('hidden');
            }
            else{
                this.player.muted = true;
                this.muted.classList.remove('hidden');
            }
        }
    }
    customElements.define('embed-video', video);

})